<template>
  <div class="rule-details">
    <div class="page-header">
      <Breadcrumb>
        <BreadcrumbItem :to="`/nodes/${nodeID}/rules`">{{ this.$t('rules.rules') }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$t('rules.topo') }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <Card shadow class="detail">
      <Spin v-if="loading" size="large" fix> </Spin>
      <div :style="topoStyle" ref="topoContainer"></div>
    </Card>
  </div>
</template>

<script>
/* eslint-disable */
import charts from 'echarts'
import _ from 'lodash'
import nodeID from '@/mixins/nodeID'
import { loadRuleTopo, viewRuleStatus } from '@/api/rules'

export default {
  name: 'RuleDetail',

  mixins: [nodeID],

  data() {
    return {
      timer: 0,
      loading: false,
      chartInstance: null,
      id: this.$route.params.ruleID,
      option: {
        title: {
          text: '',
        },
        backgroundColor: '#333844',
        tooltip: {
          show: true,
          padding: 10,
          formatter(params) {
            const { value } = params
            if (value.source && value.target) {
              return `${value.source} --> ${value.target}`
            } else {
              const templateList = Object.keys(value).map((key) => `${key}: ${value[key]}`)
              return templateList.join('<br/>')
            }
          },
        },
        animationDurationUpdate: 1000,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph',
            symbol: 'rect',
            layout: 'none',
            symbolSize: [190, 30],
            roam: true,
            label: {
              normal: {
                show: true,
                fontSize: 13,
              },
            },
            edgeSymbol: ['none', 'arrow'],
            lineStyle: {
              normal: {
                opacity: 1,
                width: 2,
                curveness: 0,
              },
            },
          },
        ],
      },
    }
  },

  computed: {
    topoStyle() {
      return {
        height: '800px',
        width: '100%',
      }
    },
  },

  mounted() {
    this.initChart()
    this.loadData()
  },

  beforeRouteLeave(from, to, next) {
    clearInterval(this.timer)
    next()
  },

  beforeDestroy() {
    clearInterval(this.timer)
  },

  methods: {
    initChart() {
      this.chartInstance = charts.init(this.$refs.topoContainer, 'dark')
      this.option.title.text = `${this.$t('rules.ruleId')}: ${this.id}`
    },
    showStatus(data, links) {
      viewRuleStatus(this.nodeID, this.id).then((statusRes) => {
        data.forEach((opt) => {
          const { data } = statusRes
          const currentValue = {}
          Object.keys(data).forEach((key) => {
            if (key.includes(opt.name)) {
              currentValue[key] = data[key]
            }
          })
          opt.value = currentValue
        })
        links.forEach((opt) => {
          opt.value = {
            source: opt.source,
            target: opt.target,
          }
        })
        this.option.series[0].data = data
        this.option.series[0].links = links
        this.chartInstance.setOption(this.option)
        this.chartInstance.resize()
      })
    },
    loadData() {
      this.loading = true
      loadRuleTopo(this.nodeID, this.id)
        .then((topoRes) => {
          const { optionData, optionLinks } = this.parseTopoData(topoRes.data)
          this.showStatus(optionData, optionLinks)
          this.timer = setInterval(() => {
            this.showStatus(optionData, optionLinks)
          }, 5000)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    parseTopoData(data) {
      let optionData = []
      let optionLinks = []
      let y = 1
      let x = 0
      const setEdges = ({ edges, source }, type, cb) => {
        if (!edges[source]) {
          return
        }
        cb()
        for (let eIndex = 0, gutter = 0; eIndex < edges[source].length; eIndex += 1, gutter += 2) {
          const edge = edges[source][eIndex]
          if (type === 'edges') {
            x = gutter
          }
          optionLinks.push({
            source,
            target: edge,
          })
          optionData.push({
            x,
            y,
            name: edge,
          })
          setEdges({ edges, source: edge }, 'edges', () => {
            y += 1
          })
        }
      }
      const setOptionDataAndLink = ({ sources, edges }) => {
        for (let sIndex = 0, gutter = 0; sIndex < sources.length; sIndex += 1, gutter += 2) {
          const source = sources[sIndex]
          optionData.push({
            x: gutter,
            y: 0,
            name: source,
          })
          setEdges({ edges, source }, 'sources', () => {
            y = 1
            x = gutter
          })
        }
      }
      try {
        setOptionDataAndLink(data)
        optionData = _.unionBy(optionData, 'name')
        optionLinks = _.uniqWith(optionLinks, _.isEqual)
      } catch (error) {
        console.error(error)
      }
      return {
        optionData,
        optionLinks,
      }
    },
  },
}
</script>

<style lang="scss"></style>
